export const ORDERED_CHANNEL_PROGRAM_DAYS = ['Yesterday', 'Today', 'Tomorrow'] as const;
